import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { updateInstance, useLocalization } from '@rready/localization';
import enLocale from '../../../../libs/localization/src/locales/portal/en.json';
import deLocale from '../../../../libs/localization/src/locales/portal/de.json';
import frLocale from '../../../../libs/localization/src/locales/portal/fr.json';
import itLocale from '../../../../libs/localization/src/locales/portal/it.json';
import azLocale from '../../../../libs/localization/src/locales/portal/az.json';

// Vue.use(VueI18n) MUST go before "new VueI18n"
// See: https://stackoverflow.com/questions/48607892/vue-i18n-cannot-read-property-config-of-undefined
Vue.use(VueI18n);

const { options } = useLocalization({
  en: enLocale,
  de: deLocale,
  fr: frLocale,
  it: itLocale,
  az: azLocale
});

const i18n = new VueI18n(options);
updateInstance(i18n);

export { i18n };
